import { PixelRatio } from 'react-native'
import { bindingTypes } from '@adalo/constants'

const getDataBindingOfType = (object, bindingData, bindingType) => {
  const binding = object.dataBinding

  if (binding && binding.bindingType === bindingType) {
    return { binding, data: bindingData }
  }
}

// Get the URL of an image asset, created using the ImageControl component in builder:
// Reference: frontend/src/components/Editor/Inspect/Libraries/ImageControl.js
export const getImageUrl = (
  { object, bindingData, componentProps, getAssetURL },
  context
) => {
  if (object.attributes.imageType === 'dynamic') {
    if (componentProps && componentProps.image) {
      const image = Array.isArray(componentProps.image)
        ? componentProps.image[0]
        : componentProps.image
      return image.uri
    } else if (
      object &&
      object.attributes &&
      object.attributes.imageBinding &&
      typeof object.attributes.imageBinding.options !== 'undefined'
    ) {
      const { options } = object.attributes.imageBinding
      const placeholderImageEnabled =
        typeof options.placeholderImageEnabled !== 'undefined'
          ? options.placeholderImageEnabled
          : null
      const placeholderImage =
        typeof options.placeholderImage !== 'undefined'
          ? options.placeholderImage
          : null
      if (placeholderImageEnabled && placeholderImage) {
        return getAssetURL(options.placeholderImage)
      }
    } else {
      return undefined
    }
  }

  if (object.attributes.imageType === 'url') {
    const { attributes } = object
    if (Array.isArray(attributes.imageURL)) {
      if (componentProps && componentProps.image) {
        return componentProps.image.uri
      } else if (
        attributes &&
        attributes.imageBinding &&
        typeof attributes.imageBinding.options !== 'undefined'
      ) {
        const { options } = object.attributes.imageBinding
        const placeholderImageEnabled =
          typeof options.placeholderImageEnabled !== 'undefined'
            ? options.placeholderImageEnabled
            : null
        const placeholderImage =
          typeof options.placeholderImage !== 'undefined'
            ? options.placeholderImage
            : null
        if (placeholderImageEnabled && placeholderImage) {
          return getAssetURL(options.placeholderImage)
        } else {
          return undefined
        }
      } else {
        return undefined
      }
    }

    return object.attributes.imageURL
  }

  const bindingInfo = getDataBindingOfType(
    object,
    bindingData,
    bindingTypes.SET_IMAGE
  )
  if (bindingInfo) {
    let { binding, data } = bindingInfo
    if (data && typeof data === 'object') {
      data = data.url
    }

    const baseURL = context.getImageUploadsBaseURL()

    if (data || !binding.includeDefault) {
      if (data && typeof data === 'string' && data.match(/^(file|data):/)) {
        return data
      }

      return data && `${baseURL}/${data}?orient`
    }
  }

  const ratio = PixelRatio.getPixelSizeForLayoutSize(1)
  let sizes = [3, 2, 1]
  sizes.sort((a, b) => Math.abs(ratio - a) - Math.abs(ratio - b))

  const largerSizes = sizes.filter(s => s >= ratio)
  const smallerSizes = sizes.filter(s => s < ratio)
  sizes = largerSizes.concat(smallerSizes)

  let filename = null

  if (object.imageId) {
    filename = `${object.imageId}@${sizes[0]}x.png`
  } else {
    for (let i = 0; i < sizes.length; i += 1) {
      const size = sizes[i]
      const key = `filename${size}x`

      if (object.attributes[key]) {
        filename = object.attributes[key]
        break
      }
    }
  }

  if (!filename) {
    return null
  }

  if (typeof filename === 'object') {
    filename = filename.url
  }

  return context.getAssetURL(filename)
}
